<template>
  <div class="mailing-page">
    <div class="mailing-page__title">{{$tMailing('Distributions')}}</div>

    <div v-if="pending" class="page__columns-inner container-inner">
      <div class="page__main-col">
        <BasePreloader/>
      </div>
    </div>
    <div v-else class="mailing-page__inner">
      <div class="mailing-page__collections">
        <div class="mailing-page__collections-group-wrap">

          <!--<div class="mailing-page__collections-group">
            <div class="mailing-page__collections-group-title">{{$tMailing('Standard subscriptions')}}</div>
            <div class="mailing-page__collections-group-inner">
              <BaseCheckbox v-model="standartGroup.news"
                            :label="this.$tMailing('News')"
                            class="mailing-page__collections-checkbox _white"/>
              <BaseCheckbox v-model="standartGroup.usefullInfo"
                            :label="this.$tMailing('Useful information')"
                            class="mailing-page__collections-checkbox _white"/>
              <BaseCheckbox v-model="standartGroup.legislation"
                            :label="this.$tMailing('Legislation')"
                            class="mailing-page__collections-checkbox _white"/>
            </div>
          </div>-->
          <div class="mailing-page__collections-group">
            <div class="mailing-page__collections-group-title">{{$tMailing('My collections')}}</div>
            <div v-for="item in collections"
                 :key="item.cmc_id"
                 class="mailing-page__collections-group-inner compilation">
              <div @click="onCollectionDelete(item.cmc_id)"
                   class="compilation__delete-button">
                <BaseSvg name="ico-cross" width="0.8rem" height="0.8rem"/>
              </div>
              <BaseCheckbox value="true"
                            disabled
                            checked
                            :label="item.category_title"
                            class="mailing-page__collections-checkbox _white"/>
              <div v-if="item.params.length" class="compilation__params">
                <div  v-for="(param, index) in item.params"
                     :key="index" class="compilation__param">
                  {{param}}
                </div>
              </div>
              <div class="compilation__button">
                <router-link-modified tag="button"
                             :to="{ name: 'vacancies', query: { category_id: item.category_id }}"
                             class="base-btn base-btn--grey-blue base-btn--small">
                  <span class="base-btn__text">{{$tMailing('Find vacancies')}}</span>
                </router-link-modified>
              </div>
            </div>

            <button @click="isOpenAddForm = true" class="mailing-page__add-button base-btn base-btn--green">
              <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>
              <span class="base-btn__text">{{$tMailing('Add collection')}}</span>
            </button>
            <collapse-transition>
              <div v-if="isOpenAddForm" class="mailing-page__collections-group-inner compilation _add-form">
              <div @click="onAddFormHide()" class="compilation__delete-button">
                <BaseSvg name="ico-cross" width="0.8rem" height="0.8rem"/>
              </div>
              <div class="mailing-collection-add">
                <div class="mailing-collection-add__inner">
                  <SDirection :value="inputs.direction_id.value"
                              :cancelable="false"
                              @input="onDirectionInput"
                              @initInput="onDirectionInput($event, true)"
                              class="mailing-collection-add__select-item _white"
                              preload/>
                  <SCategory :value="inputs.category_id.value"
                             :directionId="inputs.direction_id.value && inputs.direction_id.value.id"
                             :required="inputs.category_id.required"
                             :error="inputs.category_id.error"
                             :cancelable="false"
                             @setValue="onCategoryInput($event, false)"
                             @input="onCategoryInput"
                             class="mailing-collection-add__select-item _white"
                             preload/>

                  <button @click="onAddCollection"
                          :disabled="inputs.category_id.value === null"
                          type="button"
                          class="base-btn base-btn--grey-blue  base-btn--small">
                    <span class="base-btn__text">{{$tMailing('Add')}}</span>
                  </button>
                </div>
              </div>
            </div>
            </collapse-transition>
          </div>
        </div>

      </div>

      <div class="mailing-page__settings">
        <div class="mailing-page__settings-inner">

          <div class="mailing-page__settings-title">
            <span>{{$tMailing('Settings')}}</span>
            <BaseSvg name="ico-gear"
                     class="mailing-page__settings-title-icon"
                     width="1.7rem" height="1.7rem"/>

            <div v-if="windowSizeMixin.width < 767"
                 class="mailing-settings__toggle">
              <button type="button" @click.stop="settingsOpenToggle" class="base-btn base-btn--outline-grey mailing-settings__toggle-btn">
                <BaseSvg v-if="isSettingsOpen" name="ico-minus" width="1.2rem" height=".2rem"/>
                <BaseSvg v-else name="ico-plus" width="1.2rem" height="1.2rem"/>
              </button>
            </div>
          </div>
          <div v-if="windowSizeMixin.width < 767">
            <collapse-transition>
              <MailingSettings v-if="isSettingsOpen" />
            </collapse-transition>
          </div>
          <div v-else>
              <MailingSettings />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '../../axios'
  import {mapState} from 'vuex'
  import windowSizeMixin from '../../mixins/windowSizeMixin'
  import MailingSettings from '../../components/MailingSettings'
  import SDirection from '../../components/loadingSelects/SDirection'
  import SCategory from '../../components/loadingSelects/SCategory'
  import { CollapseTransition } from "vue2-transitions";

  export default {
    mixins: [windowSizeMixin],
    components: {
      MailingSettings,
      CollapseTransition,
      SDirection,
      SCategory
    },
    data() {
      return {
        pending: false,
        data: [],
        standartGroup: {
          news: false,
          usefullInfo: true,
          legislation: true
        },
        collections: [],
        test: true,
        isSettingsOpen: true,
        addedCollection: {
          categoryId: '',
          jobType: ''
        },
        isOpenAddForm: false,
        inputs: {
          direction_id: {
            value: null,
            error: null
          },
          category_id: {
            value: null,
            error: null
          }
        }
      }
    },
    computed: {
      ...mapState('filter', [
        'directionsList',
        'jobTypes'
      ])
    },
    methods: {
      getCollections(){
        return http.get('/api/cabinet/mailing/collection').then(({data}) => {
          this.collections = data.data
        })
      },
      settingsOpenToggle() {
        this.isSettingsOpen = !this.isSettingsOpen
      },

      onDirectionInput(value, isInit) {
        this.inputs.direction_id.value = value
        if (!isInit) this.onCategoryInput(null)
      },
      onCategoryInput(value) {
        if (shouldDirectionChange(value, this.inputs.direction_id.value)) {

          this.inputs.direction_id.value = value.category.direction_id
        }
        this.inputs.category_id.value = value
      },
      onAddCollection() {
        let sendData = {};
        sendData.category_id = this.inputs.category_id.value.id

        return http.post('/api/cabinet/mailing/collection', sendData).then(() => {
          this.getCollections()
        }).finally(()=>{
          this.collectionFieldsClear()
        })
      },
      collectionFieldsClear(){
        this.inputs.direction_id.value = null
        this.inputs.category_id.value = null
        this.isOpenAddForm = false
      },
      onCollectionDelete(id){
       return http.delete('/api/cabinet/mailing/collection', {
            params: {cmc_id: id}
          })
          .then(() => {})
          .finally(()=>{
              this.getCollections()
          })
        },
      onAddFormHide(){
        this.isOpenAddForm = false
        this.collectionFieldsClear()
      }
    },
    created() {
       this.getCollections()
    }
  };

  function shouldDirectionChange(category, direction) {
    if (!category || !category.category || !category.category.direction_id) return false

    if (!direction) return true
    return direction.id !== category.category.direction_id
  }
</script>

<style lang="less">

</style>
